import { getReloadYardAddress } from "./utils";

const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

const isObjectArray = (value) =>
  Array.isArray(value) && value.some(isPlainObject);

// The record minus its sub-lines: what every one of its rows repeats.
const parentFields = (record) => {
  const fields = {};
  Object.entries(record).forEach(([key, value]) => {
    if (isObjectArray(value)) return;
    fields[key] = isPlainObject(value) ? parentFields(value) : value;
  });
  return fields;
};

const expandRecord = (record) => {
  const branches = {};
  let rowCount = 1;

  Object.entries(record).forEach(([key, value]) => {
    if (isObjectArray(value)) {
      branches[key] = value.flatMap((element) =>
        isPlainObject(element) ? expandRecord(element) : [element],
      );
    } else if (isPlainObject(value)) {
      branches[key] = expandRecord(value);
    } else {
      return;
    }
    rowCount = Math.max(rowCount, branches[key].length);
  });

  return Array.from({ length: rowCount }, (_, index) => {
    const row = {};
    Object.entries(record).forEach(([key, value]) => {
      if (!branches[key]) row[key] = value;
      else if (index < branches[key].length) row[key] = branches[key][index];
      else if (isPlainObject(value)) row[key] = parentFields(value);
    });
    return row;
  });
};

/**
 * jsonexport writes each element of an array-of-objects field on a row of its
 * own and leaves the parent's columns blank below the first one, so the sheet
 * can't be sorted or filtered. Expand those arrays here instead: one row per
 * sub-line, each carrying its parent's values. Sibling arrays still share rows
 * the way jsonexport lays them out, and a sub-line's own blank cells stay
 * blank. Records without nested arrays pass through as one row.
 */
export const fillDownRows = (records) => records.flatMap(expandRecord);

// Utility function to build the header
export const buildHeader = (
  data,
  formattedStartDate,
  formattedEndDate,
  filter
) => {
  const header = {
    address: getReloadYardAddress(),
    items: [
      {
        value: formattedEndDate
          ? `From: ${formattedStartDate} To: ${formattedEndDate}`
          : `As of: ${formattedStartDate}`,
        type: "primaryText",
      },
    ],
  };

  if (filter?.accountId?.eq) {
    header.items.unshift({
      value: data[0]?.accountName || "",
      type: "primaryText",
    });
  }

  return header;
};
